import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Велосипедный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Популярный вид активного отдыха, имеющий множество разновидностей: от небольших прогулок и
                        экскурсий до сложных велосипедных путешествий.</p>
                    <p>Маршруты велосипедного туризма прокладываются в различной местности: по проселочным дорогам, по
                        равнинам. Для велосипедного туризма разработаны специальные конструкции велосипедов.</p>
                </div>

                <div className="pageitem">
                    <div className="two-col-cell">
                        <h3>Действующие туры</h3>
                        <ul>
                            <li><a href="https://brestobl.com/turizm/marsh/2.html">Голубые озера Полесья</a></li>
                            <li><a href="https://brestobl.com/turizm/marsh/3.html">Жемчужины и таланты Полесья</a></li>
                            <li><a href="https://brestobl.com/turizm/marsh/9.html">На родину Адама Мицкевича</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}